"use client";

import { Text } from "lucide-react";
import type { TOCItemType } from "fumadocs-core/toc";
import { Card, CardContent, CardHeader, CardTitle } from "@ocr-monorepo/ui/components/card";
import { TOCProvider, TOCScrollArea } from "@/components/toc";
import {
  TOCItem,
  TOCItems,
} from "@/components/toc/default";

export function BlogTableOfContents({ toc }: { toc: TOCItemType[] }) {
  if (toc.length === 0) return null;

  return (
    <TOCProvider toc={toc}>
      <aside className="sticky top-20 hidden self-start lg:block">
        <Card className="max-h-[calc(100dvh-6rem)] gap-2 overflow-hidden rounded-lg py-5 shadow-none">
          <CardHeader className="px-5">
            <CardTitle className="inline-flex items-center gap-1.5 font-mono text-[10px] font-medium uppercase tracking-[0.12em] text-muted-foreground">
              <Text className="size-4" aria-hidden="true" />
              On this page
            </CardTitle>
          </CardHeader>
          <CardContent className="min-h-0 px-4">
            <nav aria-label="Article table of contents">
              <TOCScrollArea className="max-h-[calc(100dvh-10rem)]">
                <TOCItems>
                  {toc.map((item) => (
                    <TOCItem key={item.url} item={item} />
                  ))}
                </TOCItems>
              </TOCScrollArea>
            </nav>
          </CardContent>
        </Card>
      </aside>
    </TOCProvider>
  );
}
